import React from "react";
import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";
import Modal from "./Modal";

const ICON_BY_VARIANT = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  error: XCircle,
};

export default function AlertModal({
  isOpen,
  title = "Bilgi",
  message,
  buttonText = "Tamam",
  variant = "info",
  onClose,
}) {
  const Icon = ICON_BY_VARIANT[variant] || Info;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="alert-modal-body">
        <div className={`alert-modal-icon ${variant}`}>
          <Icon />
        </div>

        <p className="alert-modal-text">{message}</p>

        <div className="alert-modal-actions">
          <button type="button" onClick={onClose} className="btn-submit">
            {buttonText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
